import React, { Component } from 'react';
import Button from '../common/Button';
import TextInput from '../common/TextInput';
import { FormGroup, Modal, DropdownButton, MenuItem } from 'react-bootstrap';
import Gmaps from '../common/Gmaps';
import { map } from 'lodash';
import AlertDismissable from '../common/AlertDismissable';
import { imageBasePath, appBasePath } from '../../constants/staticData';

export default class AddUserPopUp extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onFieldChange = this.onFieldChange.bind(this);
    this.dropdownSelectuserType = this.dropdownSelectuserType.bind(this);
    this.cancelPopup = this.cancelPopup.bind(this);
    this.imageUpload = this.imageUpload.bind(this);
    this.setImageURL = this.setImageURL.bind(this);
    this.declineJob = this.declineJob.bind(this);
    this.state = {
      leftDropDownVisible: false,
      userType: 'User Type',
      showpopUp: false,
      uploadImageFile: `${imageBasePath}/pic.png`
    };
    this.initialFormData = {
      name: '',
      email: '',
      password: '',
      phone: '',
      profile_photo: '',
      type_id: '',
      Reason: ''
    };
    this.formData = {
      ...this.initialFormData
    };
    this.errors = {
      name: '',
      email: '',
      password: '',
      phone: '',
      type_id: '',
      Reason: ''
    };
  }

  componentWillMount() {
    this.props.actions.hideErrorMessage();
  }
  componentWillUnmount() {
    this.props.actions.hideErrorMessage();
  }

  onFieldChange(value, name, key) {
    //alert('am here');
    this.setState({ formError: false });
    this.formData[name] = value;
    this.errors[name] = value ? false : true;
  }

  declineJob() {
    //alert('decline job')
    if (this.formData.Reason == '') {
      this.errors.Reason = true;
    } else {
      let selectedData = this.props.jobSelectedData.garagejobquotes;
      let startJobData = {
        requestId: selectedData.userbookingrequestId,
        jobId: selectedData.id,
        cancellationComment: this.formData.Reason
      };

      let routeData = `${appBasePath}/driver-dashboard`;
      this.props.actions.jobRequestStatusChange('driverdeclinejob', startJobData, this.props.router, routeData);
    }
  }

  onSubmit() {
    var data = null;
    let checkValue = document.getElementsByClassName('form-group');
    let errorMesg = 'please attach a photo to proceed further';
    map(checkValue, function(value, key) {
      data += value.className;
    });
    let checkError = data.indexOf('error') !== -1 ? true : false;
    if (checkError) {
      this.props.actions.showErrorMessage('please correct the errors on this form');
    } else if (this.state.uploadImageFile == `${imageBasePath}/pic.png`) {
      this.props.actions.showErrorMessage(errorMesg);
      // alert('please upload pick before proceeding')
    } else {
      this.formData.phone = '+971' + this.formData.phone;
      this.formData.profile_photo = this.state.uploadImageFile;
      this.props.actions.addUser(this.formData);
    }
  }
  dropdownSelectuserType(e) {
    this.setState({ userType: e.displayname });
    this.formData['type_id'] = e.id;
  }
  cancelPopup() {
    this.props.actions.hidePopUP();
  }
  setImageURL(url) {
    this.setState({ uploadImageFile: url });
  }
  imageUpload(e) {
    let file = e.target.files[0];
    let errMesg = 'Sorry, your image exceeds the file size limit of 1mb, Try again with another image.';
    let propsFunc = this.props.actions;
    let resp = '';
    let that = this;
    if (file.size >= 25000000) {
      this.props.actions.showErrorMessage(errMesg);
    } else {
      //this.setState({uploadImageFile: file.name});
      this.props.actions.sign_request(file, 'driver', function(response) {
        resp = response;
        //that.setState({uploadImageFile: resp.data.url});
        propsFunc.uploadImageDP(file, resp.data.signed_request, resp.data.url, function() {
          that.setImageURL(resp.data.url);
          that.props.actions.hideErrorMessage();
        });
      });
    }
  }
  render() {
    const authData = localStorage.businessAuthData ? JSON.parse(localStorage.businessAuthData) : '';
    const { authReducer, showpopupType, manageVehicle, actions, driverType, commonReducer } = this.props;
    return (
      <div>
        <div id="myModal" className={manageVehicle.popupToggle ? 'modal-vehicle modal' : 'modalnone-vehicle modalnone'}>
          {/*<!-- Modal content -->*/}
          {showpopupType == 'AddUser' &&
            <div className="modal-content-vehicle modal-content-mob">
              <div className="overview-heading-popup add-userh5">
                <h5>Add User</h5>
              </div>
              {authReducer &&
                authReducer.showErrorMessage &&
                authReducer.statusMessage.indexOf('garage-id') == -1 &&
                <AlertDismissable
                  bsStyle={
                    authReducer.statusMessage.indexOf('succesfully') !== -1 ? 'success error-back' : 'danger error-back'
                  }
                  closeLabel="Close alert"
                  closeAction={this.props.actions.hideErrorMessage}
                >
                  <p> <i className="mdi mdi-block-helper " /> {authReducer.statusMessage} </p>
                </AlertDismissable>}
              <div className="page-sec-header col page-sec-mob">
                <div className="">
                  <div className="row clearfix">
                    <div className="col-xs-3 popup-img-box">
                      <div className="image-element popup-image-element popup-img-mob">
                        {this.state.uploadImageFile &&
                          !commonReducer.profileImageUploaded &&
                          <img src={this.state.uploadImageFile} className="imageupl popupimage popup-img-mob" />}
                        {commonReducer.profileImageUploaded &&
                          <div className="c-loader-img">
                            <img
                              className="img-loader-on-upload imageupl popupimage popupimage-loader popup-img-mob"
                              src={`${imageBasePath}/loader_white.gif`}
                              alt="Upload in progress"
                            />
                          </div>}
                        <label htmlFor="file-upload" className="custom-file-upload custom-popup-fileupload">
                          <i className="glyphicon glyphicon-camera" />
                        </label>
                        <input id="file-upload" type="file" accept="image/*" onChange={e => this.imageUpload(e)} />
                      </div>
                    </div>
                    <div className="col-xs-9 add-user-form-mob">
                      <div className="password-form-info-popup form-info-popup-mob">
                        <TextInput
                          type="text"
                          label="Name"
                          name="name"
                          validationError={'Enter your name'}
                          showValidationError={this.errors['name']}
                          validationError="Enter your name"
                          onBlur={this.onFieldChange.bind(this)}
                        />
                        <TextInput
                          type="email"
                          label="Email Address"
                          name="email"
                          validationError="Please enter your email id"
                          showValidationError={this.errors['email']}
                          onChange={this.onFieldChange.bind(this)}
                        />
                        <TextInput
                          type="password"
                          label="Password"
                          name="password"
                          showValidationError={this.errors['password']}
                          validationError="Password should be greater than six digits"
                          onBlur={this.onFieldChange.bind(this)}
                        />
                        <TextInput
                          type="phone"
                          label="Mobile Number"
                          name="phone"
                          showValidationError={this.errors['phone']}
                          validationError="Enter a valid mobile number"
                          onBlur={this.onFieldChange.bind(this)}
                        />
                        <div className="modal-cus-Dd">
                          <DropdownButton
                            bsSize="xsmall"
                            className="selectDropDown selectDropdown-popup modal-dd-text"
                            id="dropdown-size-large"
                            onToggle={e => this.setState({ leftDropDownVisible: e })}
                            onSelect={e => {
                              this.dropdownSelectuserType(e);
                            }}
                            title={
                              <div className="input-group popup-input">
                                <span className="selected-car-name">{this.state.userType}</span>
                                <i
                                  className={
                                    this.state.leftDropDownVisible ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'
                                  }
                                />
                              </div>
                            }
                          >
                            {map(driverType, (info, index) => {
                              return <MenuItem eventKey={info}>{info.displayname}</MenuItem>;
                            })}
                          </DropdownButton>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="navigation-footer-part clearfix container add-vehcile-mob-wrapper mtop-40">
                  <Button
                    btnType="label"
                    btnSize="sm"
                    fontSize={16}
                    label="Save"
                    btnCallBack={() => this.onSubmit(this)}
                    customClass="btn-theme-save hidden-xs"
                  />
                  <Button
                    btnType="label"
                    btnSize="sm"
                    fontSize={16}
                    label="Close"
                    btnCallBack={() => this.cancelPopup()}
                    customClass="btn-theme hidden-xs"
                  />
                  <div className="row visible-xs mtop-20 ">
                    <div className="col-xs-6 add-veh-mob">
                      <Button
                        btnType="label"
                        btnSize="sm"
                        fontSize={16}
                        label="Save"
                        btnCallBack={() => this.onSubmit(this)}
                        customClass="btn-theme-save add-vehcile-save-btn m-0 popup-btn"
                      />
                    </div>
                    <div className="col-xs-6 add-veh-mob">
                      <Button
                        btnType="label"
                        btnSize="sm"
                        fontSize={16}
                        label="Cancel"
                        btnCallBack={() => this.cancelPopup()}
                        customClass="btn-theme add-vehcile-cancel-btn m-0 popup-btn"
                      />                  
                    </div>
                  </div>
                </div>
              </div>
            </div>}
          {showpopupType == 'Maps' &&
            manageVehicle.mapInfo.latitude &&
            <div className="modal-content-map">
              <div className="overview-heading-popup">
                <h5>Location</h5>
                <img src={`${imageBasePath}/delete.png`} onClick={() => this.cancelPopup()} />
              </div>
              <Gmaps
                mapDrag={()=>{
                }}
                markerDrag={()=>{}}
                center={{
                  lat: Number(manageVehicle.mapInfo.latitude),
                  lng: Number(manageVehicle.mapInfo.longititude)
                }}
                zoom={15}
                marker={{
                  position: {
                    lat: Number(manageVehicle.mapInfo.latitude),
                    lng: Number(manageVehicle.mapInfo.longititude)
                  }
                }}
                pinImage={`${imageBasePath}/drag-loc.png`}
                containerElement={<div style={{ height: 390 + 'px', width: 100 + '%' }} />}
                mapElement={<div style={{ height: 400 + 'px', width: 100 + '%' }} />}
              />
            </div>}
          {showpopupType == 'driver-decline' &&
            <div className="modal-content-map modal-content-decline">
              <div className="container-fluid">
                <div className="row clearfix">
                  <div className="col-xs-12 text-center driver-decline-popup-header">
                    Decline Job
                  </div>
                  <div className="col-xs-12 text-center driver-decline-popup-text emergency-display-map-no-border">
                    please let us know why you would like to Decline this job
                  </div>
                  <div className="col-xs-11 driver-decline-popup-text">
                    <TextInput
                      type="text"
                      label="Reason"
                      name="Reason"
                      showValidationError={this.errors['Reason']}
                      validationError="please enter decline reason"
                      onBlur={this.onFieldChange.bind(this)}
                    />
                  </div>
                  <div className="navigation-footer-part clearfix  driver-emergency-btn driver-popupfooter">
                    <Button
                      btnType="label"
                      btnSize="sm"
                      fontSize={16}
                      label="Decline"
                      btnCallBack={() => this.declineJob(this)}
                      customClass="btn-theme-save mobile-popup-size"
                    />
                    <Button
                      btnType="label"
                      btnSize="sm"
                      fontSize={16}
                      label="Cancel"
                      btnCallBack={() => this.cancelPopup()}
                      customClass="btn-theme btn-theme-size mobile-popup-size"
                    />
                  </div>
                </div>
              </div>
            </div>}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MyVehicles/AddUserPopUp.jsx